import { type HttpPost, mapServerError } from '@/shared/infra/http'
import type { SubmitFeedback, SubmitFeedbackResult } from '@/modules/feedback/use-cases'

export class SupabaseSubmitFeedbackRepository {
  constructor(private readonly http: HttpPost) {}

  execute: SubmitFeedback = async ({ orgId, orgType, attachmentPath, ...rest }) => {
    try {
      const body = {
        ...rest,
        ...(orgId && orgType ? { orgId, orgType } : {}),
        ...(attachmentPath ? { attachmentPath } : {}),
      }
      return await this.http.post<typeof body, SubmitFeedbackResult>({
        url: '/feedback',
        body,
      })
    } catch (err) {
      mapServerError(err, {})
    }
  }
}
